export class UsuarioSucursal {

 public id:number;
 public email:string;
 public codigoConsorcio:string;
 public codigoSucursal:string;
 
}


// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/usuario-sucursal.ts